import Loading from "@/components/Loading";
import AdminLayout from "@/layout/AdminLayout";
import React from "react";
import {PAGE_URL} from "../services/constant";
const TenantInvitation = React.lazy(() =>
    import('../TenantInvitation')
);
const tenantInvitationRoutesRegistry = [
    {
        path: PAGE_URL.TENANT_INVITATION_PAGE,
        element: <TenantInvitation />,
        loading: <Loading />,
        layout: AdminLayout,
    },
];

export default tenantInvitationRoutesRegistry;
